module.exports = __webpack_public_path__ + "img/IMG_2566.5af71ae7.png";